<template>
  <div class="rule-group" v-loading="loading">
    <div v-if="rulesGroup && rulesGroup.length > 0">
      <div :key="'group-' + i" v-for="(group, i) in rulesGroup">
        <template v-if="group.name">
          <div class="group-title">
            {{ group.name }}
          </div>
          <div class="group-list">
            <el-checkbox
              v-model="rule.select"
              @change="handleInputConfirm"
              :key="'rule-' + rule.value"
              v-for="(rule, i) in group.rules"
            >
              {{ rule.label }}
            </el-checkbox>
          </div>
        </template>
      </div>
    </div>
    <el-empty
      v-else-if="!loading"
      :description="errorMsg || '暂无权限选项'"
      :image-size="100"
    >
      <el-button v-if="errorMsg" @click="getRuleConfig" size="small">
        重新加载
      </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.rule-group {
  border: 1px solid #f1f1f1;
  background: #fefefe;

  .group-title {
    font-size: 14px;
    line-height: 16px;
    background: #f1f1f1;
    padding: 10px 10px;
    color: #919191;
  }

  .group-list {
    max-width: 500px;
    padding: 20px;
  }
}
</style>

<script>
export default {
  data() {
    return {
      loading: false,
      errorMsg: null,
      curRules: null,
      rulesGroup: null,
      customerConfig: null,
    }
  },
  props: {
    value: {
      type: String
    }
  },
  model: {
    event: "change",
    prop: "value"
  },
  watch: {
    value() {
      this.initValue();
    }
  },
  methods: {
    initValue() {
      this.rulesGroup.forEach(group => {
        if (group && group.rules) {
          group.rules.forEach((rule) => {
            rule.select = this.checkPower(rule.value);
          })
        }
      });
    },
    checkPower(item) {
      if (item instanceof Array) {
        let flag = true;
        item.forEach(ii => {
          flag = flag && this.checkPower(ii);
        });
        return flag;
      }
      let currentRules = (this.value || "").split("\n");
      return currentRules.some((rule) => {
        if (rule == '*') {
          return rule && true;
        }
        return rule && new RegExp(rule).test(item);
      });
    },
    addRule(rules, value) {
      if (value instanceof Array) {
        value.forEach(vv => {
          this.addRule(rules, vv);
        });
      } else {
        rules.push(value);
      }
    },
    handleInputConfirm() {
      let rules = [];
      this.rulesGroup.forEach(group => {
        if (group && group.rules) {
          group.rules.forEach((rule) => {
            if (rule.select) {
              this.addRule(rules, rule.value)
            }
          })
        }
      });
      this.$emit("change", rules.join("\n"));
    },
    getRuleConfig() {
      this.errorMsg = null;
      this.loading = true;
      return this.requestApi("api.system.global.setting.detail", {
        settingKey: 'system_global_customer_config'
      }).then((resp) => {
        return this.toAny(resp.data && resp.data.settingValue, {}) || {};
      }).then((resp) => {
        let groupConfig = this.toAny(resp.customerRoleGroup, []);
        if (groupConfig instanceof Array) {
          groupConfig.forEach(group => {
            if (group && group.rules) {
              group.rules.forEach((rule) => {
                rule.select = false;
              })
            }
          })
          this.rulesGroup = groupConfig;
        } else {
          this.rulesGroup = [];
        }
        this.initValue();
      }).catch((err) => {
        this.errorMsg = (err && (err.msg || err.message)) || "连接服务器失败，请检查网络";
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getRuleConfig();
  }
}
</script>